import logisticsHttp from '@/services/logisticsHttp'

export default {
  namespaced: true,
  state: {
    autoRouteTaskStatus: null,
    loading: false,
    error: null
  },
  getters: {
    isAutoRouteTaskActive: state => state.autoRouteTaskStatus?.is_active || false,
    isLoading: state => state.loading,
    getError: state => state.error
  },
  mutations: {
    SET_AUTO_ROUTE_TASK_STATUS(state, status) {
      state.autoRouteTaskStatus = status
    },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchAutoRouteTaskStatus({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const response = await logisticsHttp.get('/features/auto_route_task')
        commit('SET_AUTO_ROUTE_TASK_STATUS', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateAutoRouteTaskStatus({ commit }, isActive) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const response = await logisticsHttp.post('/features/auto_route_task', {
          is_active: isActive
        })
        commit('SET_AUTO_ROUTE_TASK_STATUS', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}
